<div class="row">
    <div class="col-lg-12">
        <div class="products">
            <p-table #dataTable
                     styleClass="p-datatable-striped"
                     [value]="items"

                     selectionMode="single"
                     [(selection)]="selectedArticle"
                     (onRowSelect)="onRowClick($event)"

                     responsiveLayout="stack"
                     [breakpoint]="'800px'">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 6em">
                            <span translation="Axilla.OrderGuide.Article.Picture" source="Axilla"></span>
                        </th>
                        <th>
                            <span translation="Axilla.OrderGuide.Article.Description" source="Axilla"></span>
                        </th>
                        <th style="width: 9em">
                            <span translation="Axilla.OrderGuide.Article.Price" source="Axilla"></span>
                        </th>
                        <th style="width: 6em; text-align: right">
                            <span translation="Axilla.OrderGuide.Article.ItemAmount" source="Axilla"></span>
                        </th>
                        <th style="width: 6em">
                            <span translation="Axilla.Actions" source="Axilla"></span>
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-record="$implicit">
                    <tr [pSelectableRow]="record">
                        <td class="p-0">
                            <app-image-container [articleId]="record.code" [height]="68"></app-image-container>
                        </td>
                        <td>
                            <div class="p-d-flex flex-column gap-2">
                                <div class="truncate"><strong>{{ record.title }}</strong></div>
                                <div>{{ record.code }}</div>
                                <div>
                                    <span [ngClass]="{'product-badge amount-pce': record.amount == 1, 'product-badge amount-box': record.amount > 1}">
                                        {{ record.amount }}
                                        <span *ngIf="record.amount == 1"
                                                  translation="Axilla.OrderGuide.Article.AmountPce" source="Axilla"></span>
                                        <span *ngIf="record.amount > 1"
                                              translation="Axilla.OrderGuide.Article.AmountBox" source="Axilla"></span>
                                    </span>
                                </div>
                            </div>
                        </td>
                        <td style="text-align: left; vertical-align: top;">
                            <div class="p-d-flex flex-column gap-2">
                                <div class="p-d-flex gap-2">
                                    <i class="pi pi-money-bill"></i>
                                    {{ record.price | currency:getCurrency(record.currency):'symbol-narrow':'.2-2' }}
                                </div>
                                <div class="p-d-flex gap-2">
                                    <i class="pi pi-cart-plus"></i>
                                    {{ record.purchasePrice | currency:getCurrency(record.currency):'symbol-narrow':'.2-2' }}
                                </div>
                            </div>

                        </td>
                        <td style="text-align: right; vertical-align: top;">
                            <div class="p-d-flex flex-column gap-2">
                                <div class="p-d-flex gap-2">
                                    <i class="pi pi-shopping-cart"></i>
                                    <ng-container *ngIf="isInBasket(record); else emptyBasket">
                                        {{ getBasketAmount(record) }}
                                    </ng-container>
                                    <ng-template #emptyBasket>
                                        0
                                    </ng-template>
                                </div>
                                <div class="p-d-flex gap-2">
                                    <i class="fa fa-warehouse"></i>
                                    {{ record.stockAmount }}
                                </div>
                                <ng-container *ngIf="BasePermissionDefinition.Webshop.WMS.ViewLocalStock | permission">
                                    <div class="p-d-flex gap-2" (click)="editLocalWarehouse(record)">
                                        <i class="pi pi-car"></i>
                                        <span>{{ record.localWarehouseAmount }}</span>
                                    </div>
                                </ng-container>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-around">
                                <app-universal-counter
                                    [mode]="'vertical'"
                                    [article]="record"
                                    (addToBasket)="addToBasket($event)"></app-universal-counter>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0 || primengTableHelper.isLoading">
                <span translation="Axilla.NoData" source="Axilla"></span>
            </div>

           <div class="primeng-paging-container">
               <p-paginator #paginator
                     [rows]="rowsAmount"
                     [first]="first"
                     (onPageChange)="onSearchAndLoadData($event)"
                     [totalRecords]="primengTableHelper.totalRecordsCount"
                     [rowsPerPageOptions]="rowsPerPageOptions">
                </p-paginator>
                <span class="total-records-count">
                    {{'TotalRecordsCount' | localize:total}}
                </span>
            </div>
        </div>
    </div>

</div>
